import { XMarkIcon } from '@heroicons/react/24/solid';
import { useLocation } from '@remix-run/react';

interface MasqueradeBannerProps {
  email?: string;
}

const MasqueradeBanner = ({ email }: MasqueradeBannerProps) => {
  const { pathname } = useLocation();

  const handleExit = () => {
    // Full reload to guarantee the redirect target re-runs the root loader
    // with the updated (cleared) cookies.
    window.location.href = `/masquerade/exit?page=${encodeURIComponent(pathname)}`;
  };

  return (
    <div className="relative z-[1] flex justify-between gap-3 bg-black p-4 text-gray-500">
      <div className="flex justify-between gap-3">
        <div className="mt-1.5 h-2">
          <div className="h-2 w-2 animate-pulse rounded-full bg-amber-400" />
        </div>
        <div className="flex flex-col gap-1">
          <h6 className="text-sm font-bold text-gray-100">Masquerade mode</h6>
          <p className="text-xs font-medium text-gray-400">
            {email
              ? `Viewing this site as ${email}. To return to normal, close this bar.`
              : 'Viewing this site as another subscriber. To return to normal, close this bar.'}
          </p>
        </div>
      </div>
      <div className="mt-1 flex h-6 w-6 items-center justify-center">
        <button type="button" className="group rounded-md transition-all duration-100" onClick={handleExit}>
          <XMarkIcon className="h-6 w-6 text-gray-500 group-hover:text-gray-100" />
        </button>
      </div>
    </div>
  );
};

export default MasqueradeBanner;
